const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AppointementList/AppointmentList.tsx';
import { css, cx } from '@emotion/css';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';
import { AppointmentListRow } from './AppointmentListRow';
import { Card, CardHeader } from '@mui/material';
import * as React from 'react';
import { ReactElement } from 'react';
import moment from 'moment';
import { Theme, useTheme } from '@mui/material/styles';
import { addDividers } from '@cistec/common_web/utils/ui';
import { IconClass } from '@cistec/common_web/defs/icons';
import PageSubHeader from 'App/pages/PageSubHeader';

interface IAppointmentListProps {
    groupedAppointments: StructuredAppointment[][];
    className?: string;
    title: string;
}

const cssAppointmentCardHeader = (theme: Theme) => css`
    margin: 0;
    padding: ${theme.spacing(2)} ${theme.spacing(2)} 0;

    span {
        font-weight: 500;
    }
`;

const cssAppointmentCardHeaderData = css`
    display: flex;
    justify-content: space-between;
`;

export const AppointmentList = (props: IAppointmentListProps) => {
    const theme = useTheme();

    const getAppointmentListRow = (appointment: StructuredAppointment): ReactElement<any> => {
        return <AppointmentListRow key={appointment.TERMNR} appointment={appointment} />;
    };

    return (
        <div className={cx('AppointmentList', props.className)}>
            {props.title && <PageSubHeader title={props.title} titleIcon={IconClass.Calendar} />}
            {props.groupedAppointments.map(appointments => {
                const date = moment(appointments[0].STARTDAT).format('dddd, DD. MMMM YYYY');
                const titleComponent = <div className={cssAppointmentCardHeaderData}>{date}</div>;
                return (
                    <Card style={{ marginBottom: '10px' }} key={`card_${date}`}>
                        <CardHeader
                            className={cssAppointmentCardHeader(theme)}
                            variant="body2"
                            component="h6"
                            aria-label={date}
                            title={titleComponent}
                        />
                        {addDividers(appointments.map(appointment => getAppointmentListRow(appointment)))}
                    </Card>
                );
            })}
        </div>
    );
};
